import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    login(loginArgs) {
        return axios.post(`${apiUrl}v2/auth/login`, loginArgs)
    },
    regist(registArgs) {
        return axios.post(`${apiUrl}v2/auth/regist`, registArgs)
    },
    send_verification_xyz(args) {
        return axios.post(`${apiUrl}v2/auth/send_verification_xyz`, args)
    },
    validate_password_find_verification_code(args) {
        return axios.post(`${apiUrl}v2/auth/validate_password_find_verification_code`, args)
    },
    find_password(args) {
        return axios.post(`${apiUrl}v2/auth/find_password`, args)
    },


    get_user_info() {
        return axios.get(`${apiUrl}v2/user/`)
    },
    sso_user_login(args) {
        return axios.post(`${apiUrl}v2/user/sso/login`, args)
    }
}
